import React, { useCallback, useMemo, useState } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import { Form } from '@dex/bubl-dash/src/lib/functions/useForm';
import Line from '@dex/bubl-dash/src/lib/components/Line/Line';
import Button, { ButtonRow } from '@dex/bubl-dash/src/lib/components/Button/Button';
import FieldText from '@dex/bubl-dash/src/lib/components/Fields/FieldText';
import LeaguePlayerApi from '../LeaguePlayerApi';
import Seperator from '@dex/bubl-dash/src/lib/components/Seperator/Seperator';
import DataTable from '@dex/bubl-dash/src/lib/components/DataTable/DataTable';
import FieldHidden from '@dex/bubl-dash/src/lib/components/Fields/FieldHidden';

const LeaguePlayerValidateForm: React.FC<any> = (props: any) => {

    const { form, mode, onValidated, onAttach } = props;

    const players = LeaguePlayerApi.get();
    const attach = LeaguePlayerApi.update("-", "attach");

    const handleCheckPlayers = useCallback((values) => {

        players.run({
            params: { limit: 100, where: { icNumber: values.icNumber }, include: ["owner"] }
        });

    }, []);

    const handleSelectPlayer = useCallback((player) => {

        attach.run({
            url: LeaguePlayerApi.endpoint + "/" + player.id + "/attach",
            data: { seasonId: form.values.seasonId, teamId: form.values.teamId },
            onComplete: (response) => {

                if (onAttach) onAttach(response);

            }
        })

    }, []);

    const handleCreateNew = useCallback(() => {

        form.reset(form.values);

        form.setKey();

        onValidated();

    }, [form.values.icNumber]);

    const columns: any = [
        {
            label: "Player Name",
            key: "this",
            format: "ModelLink",
        },
        {
            label: "City",
            key: "city",
        },
        {
            label: "IC Number",
            key: "icNumber",
        },
        {
            label: "User Account",
            key: "owner",
            format: "ModelLink",
        },
        (form.values.seasonId && mode === "attach") ? {
            label: "Actions",
            key: "actions",
            alignEnd: true,
            render: (value, data, app) => {
                return <Button
                    size={"small"}
                    type={"primary"}
                    label={"Select Player"}
                    loading={attach.loading}
                    onClick={handleSelectPlayer.bind(null, data)}
                />;
            }
        } : null,
    ].filter(Boolean);

    return useMemo(() => (

        <>

            <Form
                form={form}
                onSubmit={handleCheckPlayers}
                loading={players.loading}
            >

                {mode === "attach" && form.defaults.seasonId &&
                    <FieldHidden
                        form={form}
                        name="seasonId"
                        defaultValue={form.defaults.seasonId}
                    />
                }
                {mode === "attach" && form.defaults.teamId &&
                    <FieldHidden
                        form={form}
                        name="teamId"
                        defaultValue={form.defaults.teamId}
                    />
                }

                <Row gutter={8} edge={true}>

                    <Col col={{ md: 16 }}>

                        <FieldText
                            form={form}
                            name="icNumber"
                            label="IC Number"
                            required={true}
                            defaultValue={form.defaults.icNumber}
                        />

                    </Col>
                    <Col col={{ md: 8 }}>
                        <div style={{ height: 30 }}></div>
                        <Button
                            size='normal'
                            type={!players.data ? 'primary' : 'faded'}
                            label={"Check Existing Players"}
                            loading={players.loading}
                        />
                    </Col>

                </Row>

                {players.data &&
                    <Col col={{ xs: 24 }}>

                        <Seperator
                            top={"auto"}
                            bottom={"auto"}
                            heading={players.data.count.total + " Player(s) Found"}
                            description={mode === "attach" && players.data.count.total > 0 ? "Select an existing player to continue or create a new player." : null}
                        />

                        {players.data.count.total > 0 &&
                            <DataTable
                                data={players.data.data}
                                columns={columns}
                                loading={false}
                            />
                        }

                        <Line />

                        <ButtonRow>
                            <Button
                                label={"Create A New Player"}
                                onClick={handleCreateNew}
                            />
                        </ButtonRow>

                    </Col>
                }

            </Form>

        </>

    ), [props, players, attach.loading]);

}

export default LeaguePlayerValidateForm;
